import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";

const routeTitleMap: Record<string, string> = {
  "/": "titles.home",
  "/dashboard": "titles.dashboard",
  "/login": "titles.login",
  "/register": "titles.register",
  "/dashboard/settings/profile": "titles.settingsProfile", // Added /dashboard prefix
  "/todos": "titles.todos", // Assuming this is a root path or handled differently
  "/dashboard/admin/users": "titles.adminUsers",
  "/dashboard/settings/api-keys": "titles.settingsApiKeys",
  "/dashboard/short-links": "titles.shortLinks",
  "/dashboard/admin/activation/products": "titles.adminProducts",
  "/dashboard/admin/activation/codes": "titles.adminActivationCodes",
  "/my-codes": "titles.myActivationCodes",
};

const defaultTitleKey = "titles.notFound";
const appNameKey = "titles.appName";

export function useDocumentTitle() {
  const { pathname } = useLocation();
  const { t, i18n } = useTranslation();

  useEffect(() => {
    console.log("[useDocumentTitle] Pathname:", pathname); // Debug log
    let pageTitleKey = defaultTitleKey;
    if (routeTitleMap[pathname]) {
      pageTitleKey = routeTitleMap[pathname];
    } else {
      console.log("[useDocumentTitle] Pathname not in routeTitleMap, using default:", defaultTitleKey); // Debug log
    }
    console.log("[useDocumentTitle] pageTitleKey:", pageTitleKey); // Debug log

    const appName = t(appNameKey);
    const pageTitle = t(pageTitleKey);

    console.log("[useDocumentTitle] App Name:", appName); // Debug log
    console.log("[useDocumentTitle] Page Title (translated):", pageTitle); // Debug log

    document.title = `${pageTitle} - ${appName}`;
    console.log("[useDocumentTitle] Document title set to:", document.title); // Debug log
  }, [pathname, t]); // Removed i18n.language as t itself depends on it
}
